/**
 * Custom Error Handler
 *
 * Handles global errors in the support app.
 * Silently ignores expected errors (like storage/object-not-found).
 */

import { ErrorHandler, Injectable } from '@angular/core';
import { log } from '@app/_services/logger';

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  // Errors to silently ignore (expected in normal operation)
  private readonly filteredErrorCodes = new Set([
    'storage/object-not-found',
    'storage/unauthorized',
    'functions/permission-denied', // Handled by auth service
    'functions/unauthenticated',   // Handled by auth service
  ]);

  handleError(error: unknown): void {
    const errorCode = (error as { code?: string })?.code;
    if (errorCode && this.filteredErrorCodes.has(errorCode)) {
      return; // Silently ignore expected errors
    }

    log.error('ErrorHandler', 'Unhandled error', error);
  }
}
